import { defineStore } from 'pinia'
import Providers from '@/classes/sso/Providers'

export const useSsoStore = defineStore('SsoStore', {
  state: () => ({
    providers: {},
    loader: false,
    error: {}
  }),
  getters: {
    getProviders: state => () => {
      return state.$getItem({
        resource: 'providers',
        fetch: () => state.fetchProviders()
      })
    }
  },
  actions: {
    fetchProviders () {
      return this.$fetchItem({
        endpoint: '/sso/providers',
        resource: 'providers',
        model: Providers
      })
    },
    async postExchange ({ otc }) {
      await this.$pipeline({ dependencies: [otc] })

      return this.$postItem({
        endpoint: '/sso/exchange',
        params: { otc }
      })
    },
    async postCreationCancelled ({ otc }) {
      await this.$pipeline({ dependencies: [otc] })

      return this.$postItem({
        endpoint: '/sso/user_creation_cancelled',
        params: { otc }
      })
    }
  }
})